import React from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Table,
  Row,
  Col,
  Progress,
  Input
} from "reactstrap";

import axios from "axios";

import {
  PanelHeader,
  FormInputs,
  CardAuthor,
  CardSocials,
  Button,
  Statistics,
  AnimatedProgressProvider
} from "components";
import Select from "react-select";

import { thead, tbody, theadmobilebonuses } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import Switch from "react-bootstrap-switch";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import moment from "moment";
import "moment/locale/es";
import { easeQuadInOut } from "d3-ease";

var internetRate = [
  { value: "14Mbps", label: "14Mbps" },
  { value: "Default", label: "Default" }
];

const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

const SERVICIO_BOOLEAN = "serv_boolean";
const SERVICIO_STRING = "serv_string";
const SERVICIO_FORWARDING = "serv_forwarding";

//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});
const groupByID = groupBy("id");
const groupByNumber = groupBy("numero");

class CustomerMobile extends React.Component {
  constructor(props) {
    super(props);
    const groupedByNumber = groupByNumber(
      this.props.mainState.customersMobiles[this.props.match.params.customerID]
    );
    let watermark = Date.now();
    let currentMobile =
      groupedByNumber[this.props.match.params.mobileNumber][0];
    // this.props.getTodayDataUsage(currentMobile.numero);
    //console.log("#### DETALLE MOVIL " + this.props.match.params.mobileNumber + " ####");
    //console.log(groupedByNumber);
    let monthsList = this.generateMonthList();
    this.state = {
      customer: this.props.mainState.customers[
        this.props.match.params.customerID
      ][0],
      mobile: groupedByNumber[this.props.match.params.mobileNumber][0],
      loadingCDR: false,
      readyCDR: false,
      watermark: watermark,
      selectedMonth: monthsList[0]
    };
    /* ////console.log(props); */
    this.createMobiles = this.createMobiles.bind(this);
    this.createMobilesOld = this.createMobilesOld.bind(this);
    this.createUsage = this.createUsage.bind(this);
    this.createBonuses = this.createBonuses.bind(this);
    this.createServices = this.createServices.bind(this);
    this.modifyService = this.modifyService.bind(this);
    this.createMobilePUK = this.createMobilePUK.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.createUsageProgress = this.createUsageProgress.bind(this);

    // if (!(currentMobile.numero in this.props.mainState.mobileServices) || 
    //     ((currentMobile.numero in this.props.mainState.mobileServices) && this.props.mainState.mobileServices[currentMobile.numero].watermark != watermark)) {
    //   this.props.getMobileServices(
    //     currentMobile.mobile_id,
    //     currentMobile.numero,
    //     watermark
    //   );
    // }
    this.props.getMobileServicesAPI(currentMobile.numero);
  }
  componentDidMount() {
    if (this.props.mainState.mobilesCDR) {
      if (!this.state.mobile.numero in this.props.mainState.mobilesCDR ||
        !(moment().format("YYYY-MM") in this.props.mainState.mobilesCDR[this.state.mobile.numero])) {
          this.props.userData.getMobileCdrRegistries([{number: this.state.mobile.numero, customer: this.props.match.params.customerID}]);
        }
    }
  }
  createMobilesOld() {
    let mobiles = undefined;

    if (!this.props.mainState.customersMobilesLoaded) {
      mobiles = (
        <Button
          color="default"
          size="lg"
          /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          <div>
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
        </Button>
      );
    } else {
      let mobilesQuantity = 0;
      if (this.state.customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = this.props.mainState.customersMobiles[
          this.state.customer.id
        ].length;
      }

      if (mobilesQuantity > 0) mobilesQuantity = mobilesQuantity - 1; //quitamos la línea actual de la cuenta

      if (mobilesQuantity > 0) {
        mobiles = (
          <Row>
            {this.props.mainState.customersMobiles[this.state.customer.id].map(
              (mobile, key) => {
                let mobilePlan = mobile.plan
                  .replace("(Nueva) ", "")
                  .replace(" (Móvil)", "");
                let formattedNumber =
                  mobile.numero.substring(0, 3) +
                  " " +
                  mobile.numero.substring(3, 6) +
                  " " +
                  mobile.numero.substring(6, 9);
                if (mobile.numero !== this.props.match.params.mobileNumber)
                  return (
                    <Col xs={12} sm={6} key={key}>
                      <Link
                        to={
                          "/clientes/fichas/".concat(this.state.customer.id) +
                          "/movil/" +
                          mobile.numero
                        }
                      >
                        <Card color="primary" className="text-center">
                          <CardHeader className="txt-black">
                            <i className="now-ui-icons tech_mobile" />{" "}
                            {mobilePlan}
                          </CardHeader>
                          <CardBody className="text-center txt-white h5 h-nomargin">
                            {formattedNumber}
                          </CardBody>
                          <CardFooter className="text-right txt-black">
                            {mobile.precio}
                          </CardFooter>
                        </Card>
                      </Link>
                    </Col>
                  );
              }
            )}
          </Row>
        );
      } else {
        mobiles = (
          <Table responsive>
            <tbody>
              <tr>
                <td className="text-center">No tiene otro móvil...</td>
              </tr>
            </tbody>
          </Table>
        );
      }

      return mobiles;
    }

    return mobiles;
  }
  createMobiles() {
    let mobiles = undefined;

    if (!this.props.mainState.customersMobilesLoaded) {
      mobiles = (
        <Button
          color="default"
          size="lg"
          /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          <div>
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
        </Button>
      );
    } else {
      let mobilesQuantity = 0;
      if (this.state.customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = this.props.mainState.customersMobiles[
          this.state.customer.id
        ].length;
      }

      if (mobilesQuantity > 0) mobilesQuantity = mobilesQuantity - 1; //quitamos la línea actual de la cuenta

      if (mobilesQuantity > 0) {
        mobiles = (
          <Row>
            {this.props.mainState.customersMobiles[this.state.customer.id].map(
              (mobile, key) => {
                let mobilePlan = mobile.plan
                  .replace("(Nueva) ", "")
                  .replace(" (Móvil)", "");
                let formattedNumber =
                  mobile.numero.substring(0, 3) +
                  " " +
                  mobile.numero.substring(3, 6) +
                  " " +
                  mobile.numero.substring(6, 9);
                if (mobile.numero !== this.props.match.params.mobileNumber)
                  return (
                    <Col xs={12} sm={6} key={key}>
                      <Link
                        to={
                          "/clientes/fichas/".concat(this.state.customer.id) +
                          "/movil/" +
                          mobile.numero
                        }
                      >
                        <Card color="primary" className="text-center">
                          <CardHeader className="txt-black">
                            <i className="now-ui-icons tech_mobile" />{" "}
                            {mobilePlan}
                          </CardHeader>
                          <CardBody className="text-center txt-white h5 h-nomargin">
                            {formattedNumber}
                          </CardBody>
                          <CardFooter className="text-right txt-black">
                            {mobile.precio}
                          </CardFooter>
                        </Card>
                      </Link>
                    </Col>
                  );
              }
            )}
          </Row>
        );
      } else {
        mobiles = (
          <Table responsive>
            <tbody>
              <tr>
                <td className="text-center">No tiene otro móvil...</td>
              </tr>
            </tbody>
          </Table>
        );
      }

      return mobiles;
    }

    return mobiles;
  }
  // remainingUsage(usage, type, maxUsage) {
  //   let remainingUsage = 0;
  //   maxUsage = parseFloat(maxUsage);
  //   switch (type) {
  //     case "Llamadas":
  //       remainingUsage = maxUsage - Math.ceil(usage / 60);
  //       break;
  //     case "Datos":
  //       remainingUsage = (maxUsage * 1024 - usage / (1024 * 1024)) / 1024;
  //       break;
  //   }
  //   return remainingUsage;
  // }
  // getMaxUsageByType(mobile, currentDescription) {
  //   switch (currentDescription) {
  //     case "Llamadas":
  //       return parseFloat(mobile.minutos);
  //     case "Datos":
  //       return parseFloat(mobile.gigas);
  //     default:
  //       return 0;
  //   }
  // }
  // getRemainingUsageTextByType(remainingUsage, currentDescription) {
  //   switch (currentDescription) {
  //     case "Llamadas":
  //       return (
  //         <div
  //           style={
  //             {
  //               textAlign: "inherit"
  //             } /*{textAlign:"center", lineHeight: "17px"}*/
  //           }
  //         >
  //           {/*<span style={{fontSize:10}}>Quedan</span><br />*/}
  //           <span style={{ fontSize: 14, fontWeight: "bold" }}>
  //             {Math.round(remainingUsage).toLocaleString(navigator.language, {
  //               minimumFractionDigits: 0
  //             })}
  //             <span style={{ fontSize: 10 }}> minutos</span>
  //           </span>
  //         </div>
  //       );
  //     case "Datos":
  //       remainingUsage = String(remainingUsage);
  //       if (!remainingUsage.includes("."))
  //         remainingUsage = remainingUsage + ".00";
  //       remainingUsage = remainingUsage
  //         .substring(
  //           0,
  //           remainingUsage.indexOf(".") > 0
  //             ? remainingUsage.indexOf(".") + 3
  //             : remainingUsage.length
  //         )
  //         .replace(".", ",");
  //       return (
  //         <div
  //           style={
  //             {
  //               textAlign: "inherit"
  //             } /*{textAlign:"center", lineHeight: "17px"}*/
  //           }
  //         >
  //           {/*<span style={{fontSize:10}}>Quedan</span><br />*/}
  //           <span style={{ fontSize: 14, fontWeight: "bold" }}>
  //             {remainingUsage}
  //             <span style={{ fontSize: 10 }}> GB</span>
  //           </span>
  //         </div>
  //       );
  //     default:
  //       return 0;
  //   }
  // }
  
  remainingUsage(usage, type, maxUsage) {
    let remainingUsage = 0;
    maxUsage = parseFloat(maxUsage);
    switch (type) {
      case "Llamadas":
        remainingUsage = maxUsage - Math.ceil(usage / 60);
        break;
      case "Datos":
        remainingUsage = (maxUsage * 1024 - usage / (1024 * 1024)) / 1024;
        break;
    }
    return remainingUsage;
  }
  getMaxUsageByType(mobile, currentDescription) {
    switch (currentDescription) {
      case "Llamadas":
        return parseFloat(mobile.minutos);
      case "Datos":
        return parseFloat(mobile.gigas);
      default:
        return 0;
    }
  }
  createUsage() {
    // console.log("################## LOAD USAGE " + this.props.match.params.mobileNumber + " ################");
    // console.log(this.props.mainState.mobilesCDR);
    let usageCreated = null;
    let gigasString = this.state.mobile.gigas.replace(".000", "");
    let gigasInt = parseInt(gigasString);

    if (this.state.mobile.numero in this.props.mainState.mobilesCDR) {
      console.log("################## LOAD USAGE " + this.props.match.params.mobileNumber + " ################");
      console.log(this.props.mainState.todayDataUsage);
      console.log("################## ALL CDRs ################");
      console.log(this.props.mainState.mobilesCDR);
      let CDR = this.props.mainState.mobilesCDR[this.state.mobile.numero];
      let dataUsage = undefined;
      console.log("################## CDR " + this.props.match.params.mobileNumber + " ################");
      console.log(CDR);
      if (this.state.mobile.gigas > 0) {
        let currentCDRType = "Datos";
        let currentCDR = CDR[currentCDRType];
        let usage = 0.0;
        if (currentCDR !== undefined) {
          usage = parseFloat(currentCDR[0].consumo);
        }
        if (parseInt(this.state.mobile.numero) in this.props.mainState.todayDataUsage) {
          let todayUsage = this.props.mainState.todayDataUsage[parseInt(this.state.mobile.numero)];
          console.log("################## TODAY USAGE IN MOBILE NUMBER ################");
          console.log(todayUsage);
          if (todayUsage.error) todayUsage = null;
          if (!todayUsage) {
            todayUsage = [];
          } else {
            if (!usage) usage = 0.0;
          }
          try {
            usage = parseFloat(usage);
            todayUsage.map(todayUsageElemen => {
              usage += parseInt(todayUsageElemen.trafficUnits);
            });
          } catch (error) {
            try {
              let usageArrayWrapper = [];
              usageArrayWrapper.push(todayUsage);
              usage = parseFloat(usage);
              usageArrayWrapper.map(todayUsageElemen => {
                usage += parseInt(todayUsageElemen.trafficUnits);
              });
            } catch (error2) {
              console.log("Error al obtener el consumo de hoy");
              console.log(error2);
            }
          }
        }
        let maxUsage = this.getMaxUsageByType(
          this.state.mobile,
          currentCDRType
        );
        let remainingUsage = this.remainingUsage(
          usage,
          currentCDRType,
          maxUsage
        );
        let usageText = this.getRemainingUsageTextByType(
          remainingUsage,
          currentCDRType
        );
        let barColor =
          remainingUsage / maxUsage > 0.75
            ? "primary"
            : remainingUsage / maxUsage > 0.25
            ? "warning"
            : "danger";
        if (remainingUsage <= 0) {
          barColor = "danger";
          remainingUsage = maxUsage;
        }
        dataUsage = (
          <div>
            <span className="progress-badge">Datos ({gigasString}GB)</span>
            <Progress value={remainingUsage} max={maxUsage} color={barColor}>
              {usageText}
            </Progress>
            <br />
          </div>
        );
      }

      let voiceUsage = undefined;
      if (this.state.mobile.minutos > 0) {
        let currentCDRType = "Llamadas";
        let currentCDR = CDR[currentCDRType];
        let usage = 0.0;
        if (currentCDR !== undefined) {
          usage = currentCDR[0].consumo;
        }
        let maxUsage = this.getMaxUsageByType(
          this.state.mobile,
          currentCDRType
        );
        let remainingUsage = this.remainingUsage(
          usage,
          currentCDRType,
          maxUsage
        );
        let usageText = this.getRemainingUsageTextByType(
          remainingUsage,
          currentCDRType
        );
        let barColor =
          remainingUsage / maxUsage > 0.75
            ? "info"
            : remainingUsage / maxUsage > 0.25
            ? "warning"
            : "danger";
        if (remainingUsage <= 0) {
          barColor = "danger";
          remainingUsage = maxUsage;
        }
        voiceUsage = (
          <div>
            <span className="progress-badge">
              Voz ({this.state.mobile.minutos} minutos)
            </span>
            <Progress value={remainingUsage} max={maxUsage} color={barColor}>
              {usageText}
            </Progress>
            <br />
          </div>
        );
      }

      if (dataUsage == undefined && voiceUsage == undefined) {
        usageCreated = (
          <div>
            <div className="text-center">
              <i className="now-ui-icons media-2_sound-wave" /> No hay registros
              todavía
            </div>
            <br />
          </div>
        );
      } else {
        usageCreated = (
          <div>
            {dataUsage}
            {voiceUsage}
          </div>
        );
      }
    } else {
      usageCreated = (
        <div>
          <div className="text-center">
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
          <br />
        </div>
      );
    }

    return usageCreated;
  }
  generateMonthList() {
    let monthQuantity = 12;
    let values = [];
    for (let index = 0; index < monthQuantity; index++) {
      let currentMonth = moment().subtract(index, "months");
      values.push({
        value: currentMonth.format("YYYY-MM"),
        label: capitalize(currentMonth.format("MMMM YYYY"))
      });
    }
    return values;
  }
  getRemainingUsageTextByType(remainingUsage, currentDescription, cdrIsReady) {
    let isLoading = !cdrIsReady;
    let loading = <i className="now-ui-icons arrows-1_refresh-69 spin" />;
    switch (currentDescription) {
      case "Llamadas":
        return (
          <div style={{textAlign:"center", lineHeight: "17px"}}>
            <span style={{fontSize:10}}>Quedan</span><br />
            <span style={{fontSize:20, fontWeight:"bold"}}>
              {isLoading ? loading : Math.round(remainingUsage).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
            </span><br />
            <div style={{marginTop:-5}}><span style={{fontSize:10}}>minutos</span></div>
          </div>
        );
      case "Datos":
        remainingUsage = String(remainingUsage);
        if (!remainingUsage.includes("."))
          remainingUsage = remainingUsage + ".00";
        remainingUsage = remainingUsage
          .substring(
            0,
            remainingUsage.indexOf(".") > 0
              ? remainingUsage.indexOf(".") + 3
              : remainingUsage.length
          )
          .replace(".", ",");
        return (
          <div style={{textAlign:"center", lineHeight: "17px"}}>
            <span style={{fontSize:10}}>Quedan</span><br />
            <span style={{fontSize:20, fontWeight:"bold"}}>
              {isLoading ? loading : remainingUsage}
              {/* <span style={{fontSize:10}}>GB</span> */}
            </span><br />
            <div style={{marginTop:-5}}><span style={{fontSize:10}}>gigas</span></div>
            
          </div>);
      default:
        return 0;
    }
  }
  createUsageProgress(mobile) {
    // console.log("mobile", mobile);
    // console.log("createUsageProgress", mobile);
    // console.log("this.props.mainState.mobilesCDR", this.props.mainState.mobilesCDR);
    let usageCreated = null;
    if (this.props.mainState.mobilesCDR) {
      let CDR = {
        cdr: {}
      };
      let currentMobileNumberInt = undefined;
      if (mobile.mobile) currentMobileNumberInt = parseInt(mobile.mobile);
      if (mobile.numero) currentMobileNumberInt = parseInt(mobile.numero);
      if (!mobile.numero && !mobile.mobile) currentMobileNumberInt = parseInt(mobile);
      // console.log("currentMobileNumberInt", currentMobileNumberInt);
      let cdrIsReady = false;
      if (currentMobileNumberInt in this.props.mainState.mobilesCDR) {
        let currentMonth = this.state.selectedMonth.value;
        // console.log("currentMonth", currentMonth);
        let auxCDR = this.props.mainState.mobilesCDR[currentMobileNumberInt];
        // console.log("Existe el móvil en los CDR", auxCDR);
        if (currentMonth in auxCDR && auxCDR[currentMonth]) {
          auxCDR = auxCDR[currentMonth].summup;
          // console.log("auxCDR[month]", auxCDR);
          CDR.cdr = auxCDR;
          cdrIsReady = true;
        }
      } 
      
      let dataUsage = undefined;
      if (mobile.gigas > 0) {
        let currentCDRType = "Datos";
        let currentCDR = CDR.cdr[currentCDRType];
        let usage = 0.0;
        if (currentCDR !== undefined) {
          usage += currentCDR.consumo;
        }
        if (parseInt(mobile.mobile) in this.props.mainState.todayDataUsage) {
          try {
            let todayUsage = this.props.mainState.todayDataUsage[parseInt(mobile.mobile)];
            if (!todayUsage) {
              todayUsage = [];
            } else {
              // usage = 0.0;
            }
            if (todayUsage && todayUsage.length > 0) {
              try {
                usage = parseFloat(usage);
                todayUsage.map(todayUsageElemen => {
                  usage += parseFloat(todayUsageElemen.trafficUnits);
                });
              } catch (error) {
                try {
                  let usageArrayWrapper = [];
                  usageArrayWrapper.push(todayUsage);
                  usage = parseFloat(usage);
                  usageArrayWrapper.map(todayUsageElemen => {
                    usage += parseInt(todayUsageElemen.trafficUnits);
                  });
                } catch (error2) {
                  // // // console.log("Error al obtener el consumo de hoy");
                  // // // console.log(error2);
                }
              }
            }
          } catch (error) {
            // console.error(error);
          }
        }
        // // // console.log("############# CDR tipo actual [" + currentCDRType + "] - CALCULADO (usage) ################");
        // // // console.log(usage);
        let maxUsage = this.getMaxUsageByType(mobile, currentCDRType);
        // // // console.log("############# CDR tipo actual [" + currentCDRType + "] - CALCULADO (maxUsage) ################");
        // // // console.log(maxUsage);
        let remainingUsage = this.remainingUsage(usage, currentCDRType, maxUsage);
        // let usageText = this.getRemainingUsageTextByType(remainingUsage, currentCDRType);
        dataUsage = (
          <Col key={currentCDRType} xs={12} md={3}>
            <ProgressWrapper label="Counterclockwise">
              <AnimatedProgressProvider
                valueStart={maxUsage}
                valueEnd={remainingUsage}
                duration={1.4}
                easingFunction={easeQuadInOut}
              >
                {value => {
                  const roundedValue = value;
                  return (
                    <CircularProgressbarWithChildren
                      value={value}
                      maxValue={maxUsage}
                      counterClockwise
                      strokeWidth={12}
                      styles={buildStyles({
                        textColor: "black",
                        pathColor: (currentCDRType === "Datos") ? "#5279BF" :"#46B98A",
                        trailColor: "#D8D9DD",
                        pathTransition: "none"
                      })}
                    >
                      {this.getRemainingUsageTextByType(roundedValue, currentCDRType, cdrIsReady)}
                    </CircularProgressbarWithChildren>
                  );
                }}
              </AnimatedProgressProvider>
            </ProgressWrapper>
          </Col>
        );
      }
      
      let voiceUsage = undefined;
      if (mobile.minutos > 0) {
        let currentCDRType = "Llamadas";
        let currentCDR = CDR.cdr[currentCDRType];
        let usage = 0.0;
        if (currentCDR !== undefined) {
          usage += currentCDR.consumo;
        }
        let maxUsage = this.getMaxUsageByType(mobile, currentCDRType);
        let remainingUsage = this.remainingUsage(usage, currentCDRType, maxUsage);
        voiceUsage = (
          <Col key={currentCDRType} xs={12} md={3}>
            <ProgressWrapper label="Counterclockwise">
              <AnimatedProgressProvider
                valueStart={maxUsage}
                valueEnd={remainingUsage}
                duration={1.4}
                easingFunction={easeQuadInOut}
              >
                {value => {
                  const roundedValue = value;
                  return (
                    <CircularProgressbarWithChildren
                      value={value}
                      maxValue={maxUsage}
                      counterClockwise
                      strokeWidth={12}
                      styles={buildStyles({
                        textColor: "black",
                        pathColor: (currentCDRType === "Datos") ? "#5279BF" :"#46B98A",
                        trailColor: "#D8D9DD",
                        pathTransition: "none"
                      })}
                    >
                      {this.getRemainingUsageTextByType(roundedValue, currentCDRType, cdrIsReady)}
                    </CircularProgressbarWithChildren>
                  );
                }}
              </AnimatedProgressProvider>
            </ProgressWrapper>
          </Col>
        );
      }
      usageCreated = [dataUsage, voiceUsage];
    } else {
      usageCreated = 
        <Col xs={12} md={9}>
          <Statistics
            showIcon
            iconState="default"
            icon="now-ui-icons arrows-1_refresh-69 spin"
            title="Móviles"
            subtitle="Cargando..."
          />
        </Col>;
    }
    return usageCreated;
  }
  modifyService(value, service_id, service_type, service_name) {
    console.log(
      "########### SERVICE MODIFIED (" + service_id + ") ###########"
    );
    console.log("########### VALUE ###########");
    console.log(value);
    console.log("########### TYPE ###########");
    console.log(service_type);
    let extString = null;
    let extNumber = null;
    let service_json = null;
    switch (service_type) {
      case SERVICIO_BOOLEAN:
        service_json = {
          active: value,
          featureID: service_id
        };
        break;
      case SERVICIO_STRING:
        service_json = {
          active: true,
          featureID: service_id,
          extString: value
        };
        break;
      case SERVICIO_FORWARDING:
        if (value) {
          extString = this.state[service_id + "String"] ? this.state[service_id + "String"] : "";
          extNumber = this.state[service_id + "Number"] ? this.state[service_id + "Number"] : -1;
        }
        service_json = {
          active: value,
          featureID: service_id,
          extString: extString,
          extNumber: extNumber
        };
        break;
      default:
        service_json = null;
    }
    if (service_json) {
      service_json = JSON.stringify(service_json);
    } else {
      service_json = "";
    }
    this.props.modifyMobileServicesWrapper(this.state.mobile.numero, service_json, service_name);
  }
  createServices() {
    // console.log("################## LOAD USAGE " + this.props.match.params.mobileNumber + " ################");
    // console.log(this.props.mainState.mobilesCDR);
    let servicesCreated = null;

    if (this.state.mobile.numero in this.props.mainState.mobileServices /*&& this.props.mainState.mobileServices[this.state.mobile.numero].watermark == this.state.watermark*/) {
      //console.log("################## LOAD USAGE " + this.props.match.params.mobileNumber + " ################");
      //console.log(this.props.mainState.mobilesCDR);
      try {
        let foundServices = this.props.mainState.mobileServices[
          this.state.mobile.numero
        ].services.item.serviceList;/*respuesta_api.subscriptionProfileResult.item.serviceList;*/
        let switchesServices = foundServices.map((service, key) => {
          if (service.userModifiable === "false") return null;
          let isSwitch = service.featureModel !== "StringValuedService.xsd";
          let isForwarding = service.featureModel == "SimpleForwardingService.xsd";
          let serviceWidget = null;
          let isInternetRate =
            service.featureID === "Internet" || service.featureID === "LTE";
          if (isSwitch && !isForwarding) {
            serviceWidget = (
              <div>
                <Switch
                  onText={<i className="now-ui-icons ui-1_check" />}
                  offText={<i className="now-ui-icons ui-1_simple-remove" />}
                  defaultValue={service.active === "true"}
                  disabled={service.userModifiable === "false"}
                  onColor="success"
                  offColor="danger"
                  onChange={event => {
                    console.log("######## ONCHANGE EVENT ########");
                    console.log(event);
                    this.modifyService(event.state.value, service.featureID, SERVICIO_BOOLEAN, service.featureName);
                  }}
                  // labelText={service.featureName}
                />
                <span> {service.featureName}</span>
              </div>
            );
          } else if (isForwarding) {
            serviceWidget = (
              <div>
                <Switch
                  onText={<i className="now-ui-icons ui-1_check" />}
                  offText={<i className="now-ui-icons ui-1_simple-remove" />}
                  defaultValue={service.active === "true"}
                  disabled={service.userModifiable === "false"}
                  onColor="success"
                  offColor="danger"
                  onChange={event => {
                    console.log("######## ONCHANGE EVENT ########");
                    console.log(event);
                    if(!this.checkForwardingService(service.featureID)) return;
                    this.modifyService(event.state.value, service.featureID, SERVICIO_BOOLEAN, service.featureName);
                  }}
                  // labelText={service.featureName}
                />
                <span> {/*service.featureName*/}</span>
                <FormGroup>
                  <Label md={3}>{service.featureName}</Label>
                  <Input
                    type="text"
                    value={this.state[service.featureID]}
                    defaultValue={service.extString}
                    disabled={service.userModifiable === "false"}
                    onChange={value => {
                      console.log("######## ONCHANGE EVENT ########");
                      console.log(value);
                      let auxState = this.state;
                      auxState[service.featureID] = value;
                      this.setState(auxState);
                    }}
                  />
                </FormGroup>
              </div>
            );
          } else {
            if (isInternetRate) {
              serviceWidget = (
                <div>
                  <FormGroup>
                    <Label md={3}>
                      {service.featureName + " (" + service.extString + ")"}{" "}
                    </Label>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      placeholder="Velocidad"
                      name={"velocidad" + service.featureID}
                      // value={service.extString}
                      options={internetRate}
                      // onChange={value => this.setState({ selectedPlan: value })}
                      onChange={value => {
                        console.log("######## ONCHANGE EVENT ########");
                        console.log(value);
                        this.modifyService(value.value, service.featureID, SERVICIO_STRING, service.featureName);
                      }}
                    />
                  </FormGroup>
                </div>
              );
            } else {
              try {
                serviceWidget = (
                  <div>
                    <FormGroup>
                      <Label md={3}>{service.featureName}</Label>
                      <Input
                        type="text"
                        value={service.extString}
                        disabled={service.userModifiable === "false"}
                        onChange={value => {
                          console.log("######## ONCHANGE EVENT ########");
                          console.log(value);
                          this.modifyService(value, service.featureID, SERVICIO_STRING, service.featureName);
                        }}
                      />
                    </FormGroup>
                  </div>
                );
              } catch (error) {
                console.log("######## ERROR CREATING SERVICE #######");
                console.log(error);
              }
            }
          }
          return <div key={service.featureID}>{serviceWidget}</div>;
        });
        servicesCreated = (
          <div>
            <div className="text-left">{switchesServices}</div>
            <br />
          </div>
        );
      } catch (error) {
        servicesCreated = (
          <div>
            <div className="text-center">
              <i className="now-ui-icons travel_info" /> No se pudieron cargar los servicios
            </div>
            <br />
          </div>
        );
      }
    } else {
      servicesCreated = (
        <div>
          <div className="text-center">
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
          <br />
        </div>
      );
    }

    return servicesCreated;
  }
  createBonuses() {
    // console.log("################## LOAD USAGE " + this.props.match.params.mobileNumber + " ################");
    // console.log(this.props.mainState.mobilesCDR);
    let bonusesCreated = null;

    if (this.state.mobile.numero in this.props.mainState.mobileServices/* && this.props.mainState.mobileServices[this.state.mobile.numero].watermark == this.state.watermark*/) {
      //console.log("################## LOAD USAGE " + this.props.match.params.mobileNumber + " ################");
      //console.log(this.props.mainState.mobilesCDR);
      try {
        let foundBonuses = this.props.mainState.mobileServices[
          this.state.mobile.numero
        ].services.item.bonuList;/*.respuesta_api.subscriptionProfileResult.item.bonuList;*/
        let bonusItems = foundBonuses.map((bonus, key) => {
          let bonusCategory =
            bonus.category === "voice"
              ? "Voz"
              : bonus.category === "data"
              ? "Datos"
              : "Otro";
          if (bonusCategory === "Otro") return null;
          let bonusValue = "";
          if (bonusCategory === "Datos") {
            let bonusDataValue =
              parseInt(bonus.trafficLimitValue) / (1024 * 1024 * 1024);
            bonusDataValue = Math.round(bonusDataValue * 100) / 100;
            bonusValue = bonusDataValue + " GB";
          } else if (bonusCategory === "Voz") {
            let bonusVoiceValue = parseInt(bonus.trafficLimitValue);
            let hours = Math.floor(bonusVoiceValue / 60 / 60);
            let minutes = Math.floor(bonusVoiceValue / 60) % 60;
            let seconds = Math.floor(
              bonusVoiceValue - minutes * 60 - hours * 3600
            );
            bonusVoiceValue =
              hours.toString().padStart(2, "0") +
              ":" +
              minutes.toString().padStart(2, "0") +
              ":" +
              seconds.toString().padStart(2, "0");
            bonusValue = bonusVoiceValue;
          }
          return (
            <tr key={bonus.bssRefID.replace(" Renovable", "")}>
              <td>{bonus.name}</td>
              <td>{bonusCategory}</td>
              <td>{bonusValue}</td>
            </tr>
          );
        });
        bonusesCreated = (
          <Table responsive>
            <thead>
              <tr className="text-primary">
                {theadmobilebonuses.map((prop, key) => {
                  return (
                    <th key={key} className="text-center">
                      {prop}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>{bonusItems}</tbody>
          </Table>
        );
      } catch (error) {
        bonusesCreated = (
          <div>
            <div className="text-center">
              <i className="now-ui-icons travel_info" /> No se pudieron cargar los bonos
            </div>
            <br />
          </div>
        );
      }
    } else {
      bonusesCreated = (
        <div>
          <div className="text-center">
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
          <br />
        </div>
      );
    }

    return bonusesCreated;
  }
  createMobilePUK() {
    let currentNumber = this.state.mobile.numero;
    let currentServices = this.props.mainState.mobileServices;
    if (currentNumber in currentServices
        && currentServices[currentNumber].puk) {
      return (
        <Card>
          <CardHeader>
            <h5 className="title text-center">PUK</h5>
          </CardHeader>
          <CardBody>
            {/* <span className="text-center">{currentServices[currentNumber].puk}</span> */}
            <form>
              <FormInputs
                ncols={["col-md-12 pr-1"]}
                proprieties={[
                  {
                    label: "",
                    inputProps: {
                      disabled: true,
                      type: "text",
                      disabled: true,
                      defaultValue: currentServices[currentNumber].puk
                    }
                  }
                ]}
              />
            </form>
          </CardBody>
        </Card>
      );
    } else {
      return null;
    }
  }
  createCoverage(mobile) {
    let coverageStyle = {};
    let coverage = null;
    if (mobile.cobertura && mobile.cobertura.cobertura && mobile.cobertura.cobertura.length > 0) {
      // <div style={{ coverageStyle }}></div>
      mobile.cobertura.cobertura.map((currentCoverage, key) => {
        coverageStyle = {
          position: "relative",
          display: "inline-block",
          width: "25px",
          height: "25px",
          borderRadius: "50%",
          marginBottom: "-1px",
          marginRight: "5px",
          background: currentCoverage.color
        }
        if (!coverage) coverage = [];
        coverage.push(<div key={key} style={coverageStyle}></div>);
      });
    }
    return coverage;
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  render() {
    if (this.state.mobile.numero !== this.props.match.params.mobileNumber) {
      const groupedByNumber = groupByNumber(
        this.props.mainState.customersMobiles[
          this.props.match.params.customerID
        ]
      );
      let watermark = Date.now();
      let currentMobile =
        groupedByNumber[this.props.match.params.mobileNumber][0];
      this.setState({
        mobile: currentMobile,
        watermark: watermark
      });
      
      // this.props.getMobileServices(
      //     currentMobile.mobile_id,
      //     currentMobile.numero,
      //     watermark
      //   );
    }
    if (
      !(
        this.props.match.params.mobileNumber in this.props.mainState.mobilesCDR
      ) &&
      this.state.loadedCDR
    ) {
      this.setState({
        loadedCDR: false
      });
    }
    if (!this.state.loadingCDR && !this.state.loadedCDR) {
      //this.props.getMobileCDR(this.props.match.params.mobileNumber);
      this.setState({
        loadingCDR: true
      });
    }
    if (
      this.props.match.params.mobileNumber in this.props.mainState.mobilesCDR &&
      this.state.loadingCDR
    ) {
      this.setState({
        loadingCDR: false,
        loadedCDR: true
      });
    }
    let currentCustomer = this.state.customer;
    let mobiles = this.createMobiles();
    let formattedNumber =
      this.props.match.params.mobileNumber.substring(0, 3) +
      " " +
      this.props.match.params.mobileNumber.substring(3, 6) +
      " " +
      this.props.match.params.mobileNumber.substring(6, 9);
    let mobilePlan = this.state.mobile.plan
      .replace("(Nueva) ", "")
      .replace(" (Móvil)", "");
    // let usage = this.createUsage();
    let usage = this.createUsageProgress(this.state.mobile);
    let services = this.createServices();
    let bonuses = this.createBonuses();
    let mobilePUK = this.createMobilePUK();
    let coverage = this.createCoverage(this.state.mobile);
    //console.log("################## DENTRO DE DETALLE MOVIL " + this.props.match.params.mobileNumber + " ################");
    //console.log(this.state);
    //console.log("################## DENTRO DE DETALLE MOVIL " + this.props.match.params.mobileNumber + " --> USAGE ################");
    //console.log(usage);
    return (
      <div>
        <PanelHeader
          content={
            <div className="header text-center">
              <h2 className="title">{coverage}{formattedNumber}</h2>
              <p className="category">{mobilePlan}</p>
            </div>
          }
        />
        <div className="content">
          <Row>
            <Col md={8} xs={12}>
              <Card>
                <CardHeader>
                  <h5 className="title">Consumo</h5>
                </CardHeader>
                <CardBody><Row>{usage}</Row></CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <h5 className="title">Servicios</h5>
                </CardHeader>
                <CardBody>{services}</CardBody>
              </Card>
            </Col>
            <Col md={4} xs={12}>
              <Button
                color="info"
                onClick={() => this.redirectTo(window.location.pathname + "/registros")}
                block
                size="lg"
                style={{ marginTop: 0 }}
              >
                Ver registros
              </Button>
              {mobilePUK}
              <Card>
                <CardHeader>
                  <Link to={"/clientes/fichas/".concat(currentCustomer.id)}>
                    <h5 className="title">Perfil del titular</h5>
                  </Link>
                </CardHeader>
                <CardBody>
                  <form>
                    <FormInputs
                      ncols={[
                        "col-md-5 pr-1",
                        "col-md-3 px-1",
                        "col-md-4 pl-1"
                      ]}
                      proprieties={[
                        {
                          label: "DNI/NIF",
                          inputProps: {
                            disabled: true,
                            type: "text",
                            disabled: true,
                            defaultValue: currentCustomer.nif
                          }
                        },
                        {
                          label: "Username",
                          inputProps: {
                            disabled: true,
                            type: "text",
                            defaultValue: currentCustomer.username
                          }
                        },
                        {
                          label: "Email",
                          inputProps: {
                            disabled: true,
                            type: "email",
                            placeholder: currentCustomer.email
                          }
                        }
                      ]}
                    />
                    <FormInputs
                      ncols={[
                        "col-md-4 pr-1",
                        "col-md-4 pl-1",
                        "col-md-4 pl-1"
                      ]}
                      proprieties={[
                        {
                          label: "Nombre",
                          inputProps: {
                            disabled: true,
                            type: "text",
                            placeholder: "Nombre",
                            defaultValue: currentCustomer.nombre_completo
                          }
                        },
                        {
                          label: "Primer apellido",
                          inputProps: {
                            disabled: true,
                            type: "text",
                            placeholder: "Primer apellido",
                            defaultValue: currentCustomer.primer_apellido
                          }
                        },
                        {
                          label: "Segundo apellido",
                          inputProps: {
                            disabled: true,
                            type: "text",
                            placeholder: "Segundo apellido",
                            defaultValue: currentCustomer.segundo_apellido
                          }
                        }
                      ]}
                    />
                    <FormInputs
                      ncols={[
                        "col-md-4 pr-1",
                        "col-md-4 pl-1",
                        "col-md-4 pl-1"
                      ]}
                      proprieties={[
                        {
                          label: "Dirección",
                          inputProps: {
                            disabled: true,
                            type: "text",
                            placeholder: "Home Address",
                            defaultValue: currentCustomer.domicilio
                          }
                        },
                        {
                          label: "Localidad",
                          inputProps: {
                            disabled: true,
                            type: "text",
                            defaultValue: currentCustomer.localidad,
                            placeholder: "Localidad"
                          }
                        },
                        {
                          label: "Código postal",
                          inputProps: {
                            disabled: true,
                            type: "number",
                            placeholder: "Código postal",
                            defaultValue: currentCustomer.codigo_postal
                          }
                        }
                      ]}
                    />
                    {/*<FormInputs
                      ncols={["col-md-12"]}
                      proprieties={[
                        {
                          label: "About Me",
                          inputProps: {
                            type: "textarea",
                            rows: "4",
                            cols: "80",
                            defaultValue:
                              "Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo.",
                            placeholder: "Here can be your description"
                          }
                        }
                      ]}
                    />*/}
                  </form>
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <h5 className="title">Bonos</h5>
                </CardHeader>
                <CardBody>{bonuses}</CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <h5 className="title">Otros móviles</h5>
                </CardHeader>
                <CardBody>{mobiles}</CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function ProgressWrapper(props) {
  return (
    <div className="statistics" style={{ textAlign: "-webkit-center" }} >
      <div /* style={{ marginTop: 30, display: "flex" }} */>
        <div style={{ width: 100 }}>{props.children}</div>
        {/* <div style={{ marginLeft: 30 }}>
          <h3 className="h5">{props.label}</h3>
          <p>{props.description}</p>
        </div> */}
      </div>
    </div>
  );
}


export default CustomerMobile;



// WEBPACK FOOTER //
// ./src/views/Customers/CustomerMobile.jsx